import './assets/main.scss'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@popperjs/core/dist/cjs/popper.js'

import { createApp } from 'vue'
import App from './App.vue'

// Import Font Awesome core
import { library } from '@fortawesome/fontawesome-svg-core'
// Import specific icons
import { faThumbsUp, faThumbsDown, faCamera, faUndo, faRedo, faPlus } from '@fortawesome/free-solid-svg-icons'
// Import Font Awesome Vue component
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Add icons to the library
library.add( faThumbsUp, faThumbsDown, faCamera, faUndo, faRedo, faPlus )

const app = createApp( App )
// Register Font Awesome component globally
app.component( 'font-awesome-icon', FontAwesomeIcon )
app.config.devtools = false
app.mount( '#app' )
